import { ElementData, ElementsData } from '@wix/thunderbolt-symbols'

export const getPathToSelectorMap = (compId: string, elementsData: ElementsData): Record<string, string> => {
	const pathToSelectorMap: Record<string, string> = {}

	Object.keys(elementsData).forEach((nickname) => {
		const element: ElementData = elementsData[nickname]
		const path = `${compId}/${nickname}`
		pathToSelectorMap[path] = `#${compId} ${element.selector}` // we add the compId to the selector to make it unique
	})

	return pathToSelectorMap
}
